import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';

export function CountdownCalendar({ Total, start = 0, end = 0, showSeconds = true }) {
    const { t: trans } = useTranslation(["info"]);

    const Ref = useRef(null);

    const [days, setdays] = useState(0);
    const [hours, sethours] = useState(0);
    const [minutes, setminutes] = useState(0);
    const [seconds, setseconds] = useState(0);

    // Coerce Total to a finite, non-negative number so callers passing
    // undefined / null / non-numeric strings can never produce NaN in the math.
    const safeTotal = Number.isFinite(Number(Total)) ? Math.max(0, Number(Total)) : 0;
    const initialSeconds = safeTotal * 24 * 60 * 60;
    const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

    // Re-seed secondsLeft whenever Total prop changes (e.g. it arrived late
    // from an API after first render), then restart the ticking interval.
    useEffect(() => {
        setSecondsLeft(initialSeconds);
        if (Ref.current) clearInterval(Ref.current);

        Ref.current = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 0) {
                    clearInterval(Ref.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(Ref.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Total]);

    useEffect(() => {
        const d = Math.floor(secondsLeft / (60 * 60 * 24));
        const h = Math.floor((secondsLeft % (60 * 60 * 24)) / (60 * 60));
        const m = Math.floor((secondsLeft % (60 * 60)) / 60);
        const s = secondsLeft % 60;

        setdays(d);
        sethours(h);
        setminutes(m);
        setseconds(s);
    }, [secondsLeft]);

    const formatNum = (num) => String(num).padStart(2, '0');

    return (
        <div className="ofc-timer">
            <div className="ofc-timer-unit">
                <span className="ofc-timer-num">{formatNum(days)}</span>
                <span className="ofc-timer-lbl">{trans("info:day")}</span>
            </div>
            <div className="ofc-timer-unit">
                <span className="ofc-timer-num">{formatNum(hours)}</span>
                <span className="ofc-timer-lbl">{trans("info:hour")}</span>
            </div>
            <div className="ofc-timer-unit">
                <span className="ofc-timer-num">{formatNum(minutes)}</span>
                <span className="ofc-timer-lbl">{trans("info:minute")}</span>
            </div>
            <div className="ofc-timer-unit">
                <span className="ofc-timer-num">{formatNum(seconds)}</span>
                <span className="ofc-timer-lbl">{trans("info:second")}</span>
            </div>
        </div>
    )
}
